import {fetchRecordList} from "@/api/project";

/**
 * Office文档预览器
 * @author: ck
 * @date: 2025/12/11
 */
export class OfficeExporter {
    constructor(options = {}) {
        this.containerSelector = options.containerSelector || '.preview-office-viewer';
        this.apiEndpoint = options.apiEndpoint || '/api/export';
    }
    async exportAndPreview(formData, currentStep, projectId) {
        const stepData = formData[`step${currentStep}`];
        const result = await fetchRecordList(projectId);

        result.records.forEach((item, index) => {
            item.index = index + 1;
        });

        const exportData = {...stepData, recordLog: result};

        const response = await fetch(this.apiEndpoint, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(exportData)
        });

        if (!response.ok) {
            throw new Error('生成文档失败');
        }

        const blob = await response.blob();
        const previewContainer = document.querySelector(this.containerSelector);

        if (!previewContainer) {
            throw new Error('预览容器不存在，请检查DOM结构');
        }

        previewContainer.innerHTML = '';

        const { renderAsync } = await import('docx-preview');
        await renderAsync(blob, previewContainer, null, {
            className: 'docx-preview',
            inWrapper: true,
            breakPages: true,
        });
    }
}

// await handleDirectPreview3()
// if (saveFlag) {
//   // fetchSaveStep3(projectId.value, getSaveData())
// }
// currentStep.value++

// await nextTick()
// saveFlag && ElMessage.success('文档预览已生成')
// window.scrollTo({
//   top: 0,
//   behavior: 'smooth'
// })
// // 显示加载状态


// // 获取当前步骤的表单数据
// const formData = formData.value[`step${currentStep.value}`];

// 创建下载链接
// const downloadLink = document.createElement('a');
// downloadLink.href = URL.createObjectURL(blob);
// downloadLink.download = `${formData.title || '技术交底书'}.docx`;
// downloadLink.textContent = '下载文档';
// downloadLink.className = 'download-link';
// previewContainer.appendChild(downloadLink);

// loading.close();
